import { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { _UserData } from '../../infra/storage/localStorage';

interface GridContextProps {
  gridLeiaute: string;
  // eslint-disable-next-line no-unused-vars
  setGridLeiaute: (layout: string) => void;
}

const GridContext = createContext<GridContextProps | undefined>(undefined);

interface GridProviderProps {
  children: ReactNode;
}

export function GridProvider ({ children }: GridProviderProps) {
  const [gridLeiaute, setGridLeiaute] = useState<string>(() => {
    const savedLayout = _UserData.GetOtherData<string>('gridLeiaute');
    return savedLayout || 'left';
  });

  useEffect(() => {
    _UserData.SetOtherData('gridLeiaute', gridLeiaute);
  }, [gridLeiaute]);

  return (
    <GridContext.Provider value={{ gridLeiaute, setGridLeiaute }}>
      {children}
    </GridContext.Provider>
  );
}

export function useGrid(): GridContextProps {
  const context = useContext(GridContext);
  if (!context) {
    throw new Error('useGrid must be used within a GridProvider');
  }
  return context;
}
